/**
 * iziToast Vue.js Plugin.
 */

// import the toast actions.
import ToastPlugin from './toast'

export default function install (Vue, {router}) {
  Vue.prototype.$toast = ToastPlugin(Vue, router)
}



// WEBPACK FOOTER //
// ./src/plugins/toast/index.js